// extracted by mini-css-extract-plugin
module.exports = {"mainPanel":"styles__mainPanel--1xlAC","approvalActions":"styles__approvalActions--3qWDR"};